module.exports = __webpack_public_path__ + "media/head_map4_yellow.7533788c.mp4";